{
  "title": "Sedes",
  "subtitle": "Los lugares donde tu equipo marca asistencia.",
  "fields": {
    "name": "Nombre",
    "description": "Descripción",
    "address": "Dirección",
    "timezone": "Zona horaria",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "radius": "Radio esperado",
    "status": "Estado"
  },
  "status": {
    "ACTIVE": "Activa",
    "INACTIVE": "Inactiva"
  },
  "filters": {
    "search": "Buscar",
    "searchPlaceholder": "Nombre de la sede",
    "status": "Estado",
    "statusAll": "Todos los estados"
  },
  "actions": {
    "new": "Nueva sede",
    "deactivate": "Desactivar",
    "activate": "Activar"
  },
  "table": {
    "caption": "Sedes de la empresa",
    "actions": "Acciones",
    "meters": "{value} m"
  },
  "empty": {
    "title": "Todavía no hay sedes",
    "description": "Crea la primera sede para poder instalar marcadores y registrar asistencia."
  },
  "form": {
    "createTitle": "Nueva sede",
    "editTitle": "Editar sede",
    "description": "Los datos de ubicación definen la geocerca del marcador.",
    "timezoneCompanyDefault": "Usa la zona de la empresa ({timezone})",
    "timezoneSearch": "Buscar zona horaria",
    "help": {
      "description": "Opcional. Máximo 300 caracteres.",
      "timezone": "Si no eliges una, la sede usa la zona horaria de la empresa.",
      "radius": "metros, 150 por defecto"
    },
    "errors": {
      "name": "Escribe un nombre de hasta 80 caracteres.",
      "nameTaken": "Ya existe una sede con ese nombre en tu empresa.",
      "description": "La descripción no puede pasar de 300 caracteres.",
      "address": "Escribe una dirección de hasta 200 caracteres.",
      "timezone": "La zona horaria no es válida.",
      "latitude": "La latitud debe estar entre -90 y 90.",
      "longitude": "La longitud debe estar entre -180 y 180.",
      "radius": "El radio debe estar entre 20 y 2000 metros."
    }
  },
  "confirm": {
    "deactivateTitle": "Desactivar la sede",
    "deactivateDescription": "«{name}» dejará de aceptar marcaciones y sus marcadores quedarán deshabilitados.",
    "activateTitle": "Activar la sede",
    "activateDescription": "«{name}» volverá a aceptar marcaciones.",
    "note": "La información histórica se conserva tal como está."
  },
  "toast": {
    "created": "Sede creada",
    "updated": "Cambios guardados",
    "deactivated": "Sede desactivada",
    "activated": "Sede activada"
  },
  "managed": {
    "notice": "Los datos con candado vienen del sistema integrado: se cambian allí y se actualizan al sincronizar."
  }
}
